// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module--container--o6p9k","center":"index-module--center--1zTfq","logoKlondike":"index-module--logoKlondike--1Y71t"};